import Api from './Api'

const LANG = window.language

export default {
  getCities(search, offset) {
    return Api()
      .get(`/api/v1/novaposhta/cities/?search=${search}&limit=20&offset=${offset}`)
  },
  getWarehouses(city, search, offset) {
    return Api()
      .get(`/api/v1/novaposhta/warehouses/?city_ref=${city}&search=${search}&offset=${offset}`)
  },
  sendPromo(data) {
    return Api() 
      .post(`/${LANG}/send/promocode-form/`, data)
  },
  getSearch(q) {
    return Api() 
      .get(`/api/search/?search=${q}`)
  }
  
}



// WEBPACK FOOTER //
// ./src/js/shared/services/vendor.js